const fragment = `
  id
  imageUrl
`;

export const listModelImagesQuery = `
  query ListModelImages(
    $filter: ModelImageFilterInput
  ) {
    items: listModelImages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createModelImageQuery = `
  mutation CreateModelImage(
    $input: CreateModelImageInput!
    $image: Upload
  ) {
    item: createModelImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateModelImageQuery = `
  mutation UpdateModelImage(
    $input: UpdateModelImageInput!
    $image: Upload
  ) {
    item: updateModelImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteModelImageQuery = `
  mutation DeleteModelImage(
    $id: Int!
  ) {
    item: deleteModelImage(id: $id) {
      ${fragment}
    }
  }
`;

export const sortModelImagesQuery = `
  mutation SortModelImages(
    $modelId: Int!,
    $ids: [Int!]!
  ) {
    items: sortModelImages(modelId: $modelId, ids: $ids) {
      id
    }
  }
`;
